import { ReactElement } from 'react'
import { DoubleSide, Euler, MeshBasicMaterial } from 'three'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { Svg } from '@react-three/drei'

interface Props {
  hasManualLoad: boolean
  pointForIcon: ImmutableVector3
  color?: string
  rotation?: Euler
  opacity?: number
}

const ManualLoadIcon = ({
  hasManualLoad,
  pointForIcon,
  color = '#000000',
  rotation = new Euler(0, 0, 0), // No rotation to keep it vertical
  opacity = 1,
}: Props): ReactElement | null => {
  if (!hasManualLoad) return null

  // Encode the SVG content for AddCircleOutlineIcon
  const encodedSvg = encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
      color,
    )}" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>`,
  )
  const svgData = `data:image/svg+xml,${encodedSvg}`

  return (
    <Svg
      src={svgData}
      position={[pointForIcon.v.x, pointForIcon.v.y, pointForIcon.v.z]}
      scale={0.01}
      rotation={rotation}
      fillMaterial={new MeshBasicMaterial({ color, side: DoubleSide, opacity, transparent: true })}
    />
  )
}

export default ManualLoadIcon
